import * as React from "react";

function IconREASolo(props) {
  return (
    <svg width={70} height={70} viewBox="0 0 70 70" fill="none" {...props}>
      <g clipPath="url(#clip0_solo)">
        <circle cx={35} cy={35} r={35} fill="#8E4EC6" />
        <path d="M44.375 48.5V45.5C44.375 44.2071 43.861 42.9675 42.9468 42.0532C42.0325 41.139 40.7929 40.625 39.5 40.625H30.5C29.2071 40.625 27.9675 41.139 27.0532 42.0532C26.139 42.9675 25.625 44.2071 25.625 45.5V48.5C25.625 49.1213 25.1213 49.625 24.5 49.625C23.8787 49.625 23.375 49.1213 23.375 48.5V45.5C23.375 43.6103 24.1262 41.7986 25.4624 40.4624C26.7986 39.1262 28.6103 38.375 30.5 38.375H39.5C41.3897 38.375 43.2014 39.1262 44.5376 40.4624C45.8738 41.7986 46.625 43.6103 46.625 45.5V48.5C46.625 49.1213 46.1213 49.625 45.5 49.625C44.8787 49.625 44.375 49.1213 44.375 48.5Z" fill="#fff" />
        <path d="M39.875 27.5C39.875 24.8076 37.6924 22.625 35 22.625C32.3076 22.625 30.125 24.8076 30.125 27.5C30.125 30.1924 32.3076 32.375 35 32.375C37.6924 32.375 39.875 30.1924 39.875 27.5ZM42.125 27.5C42.125 31.435 38.935 34.625 35 34.625C31.065 34.625 27.875 31.435 27.875 27.5C27.875 23.565 31.065 20.375 35 20.375C38.935 20.375 42.125 23.565 42.125 27.5Z" fill="#fff" />
      </g>
      <defs>
        <clipPath id="clip0_solo">
          <rect width={70} height={70} fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}

const MemoIconREASolo = React.memo(IconREASolo);
export default MemoIconREASolo;
